<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center h-100 min-w-25 wc-employee-login-form mx-auto"
  >
    <WCSpinner v-if="loading" position="center" size="xl" />

    <div v-else class="card shadow-sm w-100">
      <div class="card-body wc-login-card-body p-3 p-md-5 d-flex justify-content-center w-100">
        <!-- START : LOGIN FORM -->
        <form @submit.prevent="submit" class="w-100">
          <div class="d-flex mb-3 justify-content-between align-items-center">
            <h2 tabindex="-1" ref="focusFirst">{{ $t('employeeLogin') }}</h2>
          </div>

          <WCFormGroup :field="$v.form.account">
            <WCLabel for="wc-employee-login-form__account">{{ $t('loginId') }}</WCLabel>
            <WCValidatedInput
              id="wc-employee-login-form__account"
              v-model="form.account"
              :vuelidateObject="$v.form.account"
              >{{ $t('fieldIsRequired') }}</WCValidatedInput
            >
            <WCValidationErrors />
          </WCFormGroup>

          <WCFormGroup :field="$v.form.password">
            <WCLabel for="wc-employee-login-form__password">{{ $t('password') }}</WCLabel>
            <WCPasswordInput
              id="wc-employee-login-form__password"
              v-model="form.password"
              :vuelidate-object="$v.form.password"
            />
            <WCValidationErrors />
          </WCFormGroup>

          <button class="btn btn-primary btn-block" :disabled="$v.form.$invalid">
            {{ $t('logIn') }}
          </button>
        </form>
        <!-- END : LOGIN FORM -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCValidatedInput from '@/modules/forms/components/WCValidatedInput/WCValidatedInput.vue';
import WCPasswordInput from '@/modules/forms/components/WCPasswordInput/WCPasswordInput.vue';
import redirectFallbackHome from '@/router/redirects/redirect-fallback-home/redirect-fallback-home';
import FocusMixin from '@/mixins/FocusMixin';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ToastService from '@/modules/toasts/services/ToastService';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';

export default {
  name: 'WCEmployeeLogin',
  components: {
    WCFormGroup,
    WCValidatedInput,
    WCPasswordInput,
    WCValidationErrors,
    WCLabel,
    WCSpinner,
  },
  data() {
    return {
      form: {
        account: '',
        password: '',
      },
      passwordHidden: true,
      loading: false,
    };
  },
  mixins: [FocusMixin], // Mixin for main content focus via routing
  methods: {
    reset() {
      // reset form validation errors
      this.$v.$reset();
      // reset form data
      this.form.account = '';
      this.form.password = '';
    },
    togglePasswordHidden() {
      this.passwordHidden = !this.passwordHidden;
    },
    submit() {
      this.login({ account: this.form.account, password: this.form.password });
    },
    async login(payload) {
      try {
        this.loading = true;
        await axios.post('api/employee/password', payload);
        await redirectFallbackHome(this.$router);
      } catch (error) {
        this.reset();
        console.error(error);
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : this.$t('loginFailure');
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('error'),
            message,
          },
          timeout: 7000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    passwordInputType() {
      return this.passwordHidden ? 'password' : 'text';
    },
    passwordIcon() {
      return this.passwordHidden ? 'eye' : 'eye-slash';
    },
  },
  validations: {
    form: {
      account: {
        required,
      },
      password: {
        required,
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

@include media-breakpoint-up(md) {
  .wc-employee-login-form {
    width: 25rem;
  }
}
</style>
